import React ,{Component} from 'react'; 
import { NavLink,Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';

import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow';
import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';



const headCells = [


 
  
  { id: 'co_name', numeric: false, label: 'Name' },
 
 
   { id: '',  label: '' },
  ]
  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = styled(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = styled({   
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class AddCountry extends Component {
	
    constructor(props) {
    super(props);
   
      this.state = {redirect: false,
      countrydata:[],conid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:10,
	 
	  order:'desc' ,orderBy:'',names:'',searchcountry:'',btndisabled:false,submitbtn:"Submit",
	          
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   
	}
	
	updateDonenewParent = (text) => { this.apicall(this.state.page,this.state.rowsPerPage); }
	
	
	



	componentWillMount() {
		document.title = "Isifol - Country";
	
	if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
	this.props.parentdasCallback(
           "Country~"
        ); 
	
	 
  this.apicall(this.state.page,this.state.rowsPerPage);
  
} 
	apicall(page,rowsPerPage){
	 
	 axios.get(localStorage.getItem("ISIurl")+'ajaxcountry.php?action=getall&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  countrydata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
			
	 
     }
	 else{
		   this.setState({countrydata:[],totaldata:0});
	 }
 
    });
}


handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 

myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
}






handleChangePage = (event, newPage) => {  

 
    this.setState({  
      page: newPage,
      rowsPerPage:this.state.rowsPerPage
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage);  });
   
 
    
  }; 
  
  handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
  

   
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    },()=>{ this.apicall(this.state.page,this.state.rowsPerPage); }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'desc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'asc' : 'desc'
   
  });
};


      countryDelete(conid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r === true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('co_id',conid)
	 	   
	formData.append('userid',localStorage.getItem("isiuserid"))
	
	
	 axios.post(localStorage.getItem("ISIurl")+"ajaxcountry.php", formData, {
        }).then(res => {
    
             this.apicall(this.state.page,this.state.rowsPerPage);
    
            });
 }
      }
      Countryaddbox(val){
        this.setState({ coid: val });  
  
         setTimeout(() => this.refs.AddCountrybox.handleClickOpen(),500);

      }

render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
   



   <div className="searchbox">


  
  <ul>
  
 <li>
 <p>Name</p>
 <p ><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.names}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="Name"
            name="names" onChange={this.myChangeHandler} className="txtbox"
		
          /></p></li>
		
			
	
	
		
		<li><p>&nbsp;</p><p>
		<Button variant="contained" onClick={this.handleClickSearch} className="frmSecondarybtn" endIcon={<SearchIcon />}>
        Search
      </Button></p>
		</li> 
		
		
		
		
		</ul>
		
</div>		


<div className="contentbackbtn"> 

<div className="split-button-wrap"><p>&nbsp;</p><a  data-tag="primary_action"  className="newitem"  onClick={()=>{this.Countryaddbox(0)}}>New </a><div className="toggle caret newitem button" tag="toggle" tabindex="0" role="button" data-element="open" aria-haspopup="true" aria-label="More actions"><ul className="UIMenu" data-tag="secondary_actions" data-role="secondary_actions" data-ui-widget="UIMenu" data-component="menu"><li className="item_0 last" ><a data-tooltip="Import Journals" aria-haspopup="true" className="UILink" data-tag="journal_import_dialog" data-role="journal_import_dialog" data-ui-widget="UILink" data-component="link" href="#/adminstate"  >Manage Zipcode</a></li></ul></div></div>	

</div>
<div className="clear"></div>

<AddCountrybox ref="AddCountrybox" id={this.state.coid}  updateDonenew={this.updateDonenewParent}/>
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.countrydata.length}
            />
                      <TableBody>
                     {stableSort(this.state.countrydata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.co_name}</TableCell>

<TableCell align="left">
<div className="actionbtns">
<Button variant="contained" className="frmSecondarybtn" onClick={()=>{this.Countryaddbox(item.co_id)}} endIcon={<EditIcon />}>
Edit
</Button>&nbsp;

{item.locnt==="0" && (
<Button variant="contained" className="frmthirdbtn" onClick={()=>{this.countryDelete(item.co_id)}} endIcon={<DeleteIcon />}>
  Delete
</Button>
)}

 


 </div>
 
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colspan="2">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[10,20, 50, 100]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onChangePage={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />   
  </Paper>
    

 </React.Fragment> 

 
 
  );
}
}


export  class  AddCountrybox extends Component {

   constructor(props) {
      super(props)
	  
      this.state = {
		  
		   open:false,name:'',co_id:0,
      errormessage:'',erropen:false,btndisabled:false,
submitbtn:"Save"
	  }
      
  }
  
  
  

  
 Countrygetdata() {
	
  if(this.props.id!==0)
  {
	  
	   axios.get(localStorage.getItem("ISIurl")+'ajaxcountry.php?action=getall&co_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
     
      co_id:resp.data[0].co_id,
	  name: resp.data[0].co_name,
      cmpnyid: resp.data[0].co_cmp_id,
   	
    });
	
  }
  
});
	  
  }else{
	 this.setState({  
	  name:'',
	 co_id:0,
	 cmpnyid:'',
	   
	 
	  }); 
 }
  
    }

onclickcountryclose = (e) => {
	 this.setState({open:false});
}
handleClickOpen = (e) => {
 
  this.setState({open:!this.state.open,  name:'',cmpnyid:'',
     errormessage:'',erropen:false,
	  });
		this.Countrygetdata();
		


};
myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 
  this.setState({[nam]: val});

  

}




handleClose = (e) => {
	
 let name = this.state.name;
 
 
if(name==="")
{
	
	this.setState({errormessage:"Please Enter Country",erropen:true});
		
		 return false;
	
	
}




 this.setState({btndisabled:true,submitbtn:"Processing..."})
   var formData = new FormData();
  
  
   if(this.state.co_id===0)
	  {
		  formData.append('co_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('co_id',this.state.co_id)
		
          }
	  
	  
	  
	  
	 
        formData.append('action','insertorupdate') 
		
		formData.append('co_name',name)
		formData.append('co_cmp_id',localStorage.getItem("ISIcmpid"))
		formData.append('userid',localStorage.getItem("ISIuserid"))
		  
		axios.post(localStorage.getItem("ISIurl")+"ajaxcountry.php", formData, {
        }).then(res => {
    
	
	
	if(res.data === -1)
{ 
	 

		this.setState({errormessage:"Name Already Exist.",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}
	
	
            this.props.updateDonenew();
    
        });
  
	
	this.setState({ open:false,btndisabled:false,
	 submitbtn:"Save", });
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

	


render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.onclickcountryclose} maxWidth="xs" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Manage Country</DialogTitle>
      <DialogContent>
	  
<div className="formlist">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
						  
		
						  
	<p> <span className="validation">*</span> Name</p>
	
	<p><TextField name="name" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.name}
			 
			
			  inputProps={{tabIndex: "1",maxLength:150}} className="txtbox"
	   InputLabelProps={{ shrink: true }}
                          /></p>	
						  
	
						 	
				
       <div className="actionbtns">
	   <div className="cancelbtn">
	   <Button variant="contained" className="frmthirdbtn" onClick={this.onclickcountryclose}>
Cancel
</Button>
</div> 
<div className="savebtn">
<Button variant="contained" className="frmSecondarybtn" onClick={this.handleClose}>
    {this.state.submitbtn}
</Button>
    </div>        


	
<div className="clear"></div>

 </div>     
	</div>		 
						    </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
 
} 
  